/**
 * fs-ga4
 * /voiceなどWPのサブディレクトリ配下のリンクは除外
 * / や /c/, /p/, /f/, /b/, /my/ で始まるリンクのみクッキーを付与
 * クッキー名	意味
 * wp_referrer_first	最初に訪れたWP
 * wp_referrer_last	最後に訪れたWP
 */

/**
 * fs-ga4
 */

function initToFutureshopLinks() {
  const DEBUG = false; // 本番では false 推奨
  const WP_DIRS = ['album', 'blog', 'example', 'faq', 'hanaokuri', 'info', 'journal', 'voice'];

  // 呼び出し回数の可視化（原因追跡用）
  window.__refTrackCallCount = (window.__refTrackCallCount || 0) + 1;
  if (DEBUG) console.log(`[RefTrack] initToFutureshopLinks call #${window.__refTrackCallCount}`);

  // 現在ページが属する WP ディレクトリ
  const currentPath = window.location.pathname;
  const currentWp = WP_DIRS.find(dir =>
    currentPath === `/${dir}` || currentPath.startsWith(`/${dir}/`)
  ) || 'root';

  // ===== first（初回だけ） =====
  if (!window.__refTrackFirstInitialized) {
    const today = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date());

    const cookieOptionsPersistent = `; path=/; Secure; SameSite=Lax`;
    const existingFirst = document.cookie.match(/(?:^|; )wp_referrer_first=([^;]+)/);
    const existingDate  = document.cookie.match(/(?:^|; )wp_referrer_first_date=([^;]+)/);

    if (!existingFirst || existingDate?.[1] !== today) {
      document.cookie = `wp_referrer_first=${currentWp}${cookieOptionsPersistent}`;
      document.cookie = `wp_referrer_first_date=${today}${cookieOptionsPersistent}`;
      if (DEBUG) console.log(`[RefTrack] Set wp_referrer_first = ${currentWp}, date = ${today}`);
    } else if (DEBUG) {
      console.log(`[RefTrack] wp_referrer_first already set: ${existingFirst[1]}, date: ${existingDate?.[1]}`);
    }

    // このページライフサイクルでは以後 first 処理を実行しない
    window.__refTrackFirstInitialized = true;

    if (DEBUG) console.log(`[RefTrack] Current cookies:`, document.cookie);
  }

  // ===== last（リンクごと・何度でも） =====
  const isWpPath = (pathname) =>
    WP_DIRS.some(dir => pathname === `/${dir}` || pathname.startsWith(`/${dir}/`));

  const links = document.querySelectorAll(`a[href^="/"], a[href^="https://www.hanaimo.com/"]`);
  links.forEach(link => {
    if (link.dataset.wpTracked === 'true') return;

    const href = link.getAttribute('href');
    if (!href) return;

    try {
      const linkUrl = new URL(href, window.location.origin);
      if (linkUrl.origin !== window.location.origin) return; // 他ドメイン除外

      const pathname = linkUrl.pathname;
      if (isWpPath(pathname)) return; // WP内部リンク除外

      // Futureshop 側へ送客するリンク
      link.addEventListener('click', () => {
        const cookieOptionsSession = `; path=/; Secure; SameSite=Lax`; // セッションCookie
        document.cookie = `wp_referrer_last=${currentWp}${cookieOptionsSession}`;
        if (DEBUG) console.log(`[RefTrack] Clicked Futureshop link → wp_referrer_last = ${currentWp}`);
      });

      link.dataset.wpTracked = 'true'; // 二重登録防止
    } catch (e) {
      if (DEBUG) console.warn(`[RefTrack] Invalid URL skipped: ${href}`, e);
    }
  });
}

// 初回読み込み & HTMXのswap後に実行（firstは1回だけ、last用の付与は都度）
document.addEventListener('DOMContentLoaded', initToFutureshopLinks);
document.addEventListener('htmx:afterSwap', initToFutureshopLinks);
